<template>
    <div ID="ID-DIV-base-page-srp">
        <div v-if="data_local_lga_facility_submission_parsed_selected.length!=undefined && data_local_lga_facility_submission_parsed_selected.length!=0">
            <v-row id="ID-DIV-page-component-panel-control">
                <v-col cols="12">
                    <div>
                        <v-row>
                            <v-col xs="12" sm="12" md="6" lg="6" class="text-left">
                                <h2 class="app-class-section-headings">
                                    <!-- replace all underscores in a facility-name with spaces-->
                                    <strong>{{data_facility_name.replace(/_/g," ")}}</strong>
                                </h2>
                            </v-col>
                            <v-col xs="12" sm="12" md="6" lg="6" class="text-right">
                                <p>
                                    <strong>Certificate Of Standard</strong>
                                </p>
                                <v-btn icon x-large :color="data_btn_state_color_standard_status_check" 
                                @click="meth_click_standard_check">
                                    <v-icon>mdi-check-circle-outline</v-icon>
                                </v-btn>
                                <v-btn icon x-large :color="data_btn_state_color_standard_status_cancle" 
                                @click="meth_click_standard_cancle">
                                    <v-icon>mdi-close-circle-outline</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col xs="12" sm="12" md="12" lg="12">
                                <h4 class="app-class-section-headings">
                                    <strong>Submission Time : {{data_selected_submission_date}}</strong>
                                </h4>
                                <p>
                                    View submission reports. Select State, LGA and facility below to see the facility's reports.
                                </p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col xs="6" sm="6" md="2" lg="2">
                                <v-select
                                :items="data_local_states"
                                v-model="data_selected_state"
                                @change="meth_select_state"
                                label="state"
                                outlined
                                dense
                                ></v-select>
                            </v-col>
                            <v-col xs="6" sm="6" md="2" lg="2">
                                <v-select
                                :items="data_local_lgas"
                                v-model="data_selected_lga"
                                @change="meth_select_lga"
                                label="LGAs"
                                outlined
                                dense
                                ></v-select>
                            </v-col>
                            <v-col xs="6" sm="6" md="2" lg="2">
                                <v-select
                                :items="data_local_lga_facility_names"
                                v-model="data_selected_facility_name"
                                @change="meth_select_facility_name"
                                label="facility"
                                outlined
                                dense
                                ></v-select>
                            </v-col>
                            <v-col xs="6" sm="6" md="2" lg="2">
                                <v-select
                                :items="data_local_lga_facility_submissions"
                                v-model="data_selected_submission_id"
                                @change="meth_select_submission"
                                label="submissions"
                                outlined
                                dense
                                ></v-select>
                            </v-col>
                            <v-col v-if="!data_is_mobile" xs="6" sm="6" md="4" lg="4">
                                <div class="text-right">
                                    <v-btn color="light" @click="meth_route_link_pdf" >
                                        Download Pdf
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
            <v-row id="ID-DIV-page-component-panel-general-info">
                <v-col cols="12">
                    <div>
                        <h2 class="app-class-section-headings">
                            <strong>General Information</strong>
                        </h2>
                        <!-- ===================================================== -->
                        <!-- SLOT FOR THE PARENT MODULE general_info section -->
                        <!-- ===================================================== -->
                        <slot 
                        name="slot_general_info"
                        v-bind:submission="data_local_lga_facility_submission_parsed_selected">
                        </slot>
                        <!-- ===================================================== -->
                    </div>
                </v-col>
            </v-row>
            <v-row id="ID-DIV-page-component-panel-media">
                <v-col cols="12">
                    <div>
                        <h2 class="app-class-section-headings">
                            <strong>Media</strong>
                        </h2>
                        <!-- ===================================================== -->
                        <!-- SLOT FOR THE PARENT MODULE media section -->
                        <!-- ===================================================== -->
                        <slot 
                        name="slot_media"
                        v-bind:submission="data_local_lga_facility_submission_parsed_selected">
                        </slot>
                        <!-- ===================================================== -->
                    </div>
                </v-col>
            </v-row>
            <v-row id="ID-DIV-page-component-panel-priority-areas">
                <v-col cols="12">
                    <div>
                        <h2 class="app-class-section-headings">
                            <strong>Priority Areas</strong>
                        </h2>
                        <ComponentScoreCard
                        v-bind:prop_submission_review_1="data_local_lga_facility_submissions_parsed_review_1" 
                        v-bind:prop_submission_review_2="data_local_lga_facility_submissions_parsed_review_2" 
                        v-bind:prop_submission_review_3="data_local_lga_facility_submissions_parsed_review_3"/>
                    </div>
                </v-col>
            </v-row>
            <div class="card mt-12" id="ID-DIV-page-component-panel-services-summaries">
                <div class="card-header bg-white" style="height:3rem;">
                    <p class="text-center">
                        <strong>Keys : </strong>
                        <span>
                            <v-icon color="red" medium style="transform: rotate(180deg);">
                                mdi-triangle
                            </v-icon>
                            No/Not Available 
                        </span>
                        <span>
                            <v-icon color="green" medium>mdi-triangle</v-icon>
                            Yes/Available 
                        </span>
                        <span>
                            <strong>-</strong>
                            Not Applicable
                        </span>
                    </p>
                </div>
                <div class="card-body">
                    <v-row>
                        <v-col cols="12">
                            <!-- ===================================================== -->
                            <!-- SLOT FOR THE PARENT MODULE services_summary section -->
                            <!-- ===================================================== -->
                            <slot 
                            name="slot_services_summaries"
                            v-bind:submission="data_local_lga_facility_submission_parsed_selected">
                            </slot>
                            <!-- ===================================================== -->
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
        <div v-else>
            <v-row>
                <v-col cols="12" style="text-align:center;">
                    <v-progress-circular
                    :size="70"
                    :width="7"
                    color="green"
                    indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </div>
        <v-row>
            <v-col cols="12">
                <ComponentLoadingIndicator 
                v-bind:prop_show="data_component_loading_indicator.prop_show"
                v-bind:prop_type="data_component_loading_indicator.prop_type" 
                v-bind:prop_heading="data_component_loading_indicator.prop_heading" 
                v-bind:prop_message="data_component_loading_indicator.prop_message" 
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

//########################################
//IMPORTS libs
//########################################
import {Facades_Apps_Urls} from '@/libs/links/links_to_pages.js';
import {Facade_Mobile_Detect} from '@/libs/facades/facade_helpers.js';
import {Facade_Logger} from '@/libs/facades/facade_logger.js';
import {Api_Client_E4e_Fmoh_Iss} from '@/libs/services_clients/api_client_fmoh_iss';

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentLoadingIndicator from '@/components/ComponentLoadingIndicator';
import ComponentScoreCard from '@/components/ComponentScoreCard';

//########################################
//CONST AND VARS
//########################################

//########################################
//MAIN
//########################################

export default {
    name: 'BasePageSrp',

    components: {
        //GENERIC COMPONENTS
        ComponentLoadingIndicator,
        ComponentScoreCard

        //MODULE COMPONENTS
    },

    props:[
        'prop_srp_pdf_module_name'
    ],

    created:function()
    {
        action_on_page_load.call(this)
    },

    methods:{
        meth_select_state:function()
        {
            Facade_Logger.log("SELECT_STATE");
            action_select_state.call(this);
        },
        meth_select_lga:function()
        {
            Facade_Logger.log("SELECT_LGA");
            action_select_lga.call(this);
        },
        meth_select_facility_name:function()
        {
            Facade_Logger.log("SELECT_FAC");
            action_select_facility_name.call(this);
        },
        meth_select_submission:function()
        {
            Facade_Logger.log("SELECT_SUB");
            action_select_submission.call(this);
        },
        meth_route_link_pdf:function()
        {
            //OPEN IN NEW TAB
            window.open(
                Facades_Apps_Urls.modules_page_srp_pdf(
                    this.prop_srp_pdf_module_name,
                    this.$route.params.username,
                    this.$route.params.form_name,
                    this.$route.params.form_id,
                    this.data_selected_submission_id
                )
            )
            //NAV TO URL
            /*this.$router.push(
                {
                    name:this.prop_srp_pdf_module_name,
                    params:{
                        username:this.$route.params.username,
                        form_name:this.$route.params.form_name,
                        form_id:this.$route.params.form_id,
                        submission_id:this.data_selected_submission_id
                    }
                }
            )*/
        },
        meth_click_standard_check:function()
        {
            this.data_btn_state_color_standard_status_check="green";
            this.data_btn_state_color_standard_status_cancle="grey";
        },
        meth_click_standard_cancle:function()
        {
            this.data_btn_state_color_standard_status_cancle="red";
            this.data_btn_state_color_standard_status_check="gery";
        }
    },

    data: function()
    {
        return {
            //COMPONENT_PROPERTIES-ComponentLoadingIndicator
            data_component_loading_indicator:{
                prop_show:false,
                prop_type:"L",
                prop_heading:"loading default",
                prop_message:"please wait"
            },

            data_btn_state_color_standard_status_check:"grey",
            data_btn_state_color_standard_status_cancle:"grey",

            data_selected_state:"",
            data_selected_lga:"",
            data_selected_facility_name:"",
            data_selected_submission_id:"",
            data_selected_submission_date:"",

            data_local_submissions_summary:[],
            data_local_lga_facility_submission_parsed_selected:[],
            data_local_lga_facility_submissions_parsed_review_1:[],
            data_local_lga_facility_submissions_parsed_review_2:[],
            data_local_lga_facility_submissions_parsed_review_3:[],
            data_local_states:[],
            data_local_lgas:[],
            data_local_lga_facility_names:[],
            data_local_lga_facility_submissions:[]
        }
    },

    computed:{
        //============================
        //LOCAL COMPUTED
        //============================

        data_is_mobile:function()
        {
            var is_mobile = Facade_Mobile_Detect.check();
            return is_mobile
        },

        data_facility_name:function()
        {
            if(this.data_local_lga_facility_submission_parsed_selected!=undefined && this.data_local_lga_facility_submission_parsed_selected.length == 0)
            {
                return undefined;
            }
            else
            {
                return this.data_local_lga_facility_submission_parsed_selected[0].info.facility_name
            }
        },

        //============================
        //VUEX COMPUTED HELPERS
        //============================
        ...mapGetters(
            {
                data_store_submissions_summary: 'data_submissions_summary_getstate_all'
            }
        )
    }
};

//call all with signature func_imp.call(this,param_1,param_2)
//########################################################################################
//HELPERS
//########################################################################################

/**
 * a utility empty promise resolver for passing data
 * 
 * @param {Object} param_data any data to pass
*/
function helper_empty_promise_resolve(param_data)
{
    //OBJ CONTEXT
    var self=this;
    
    return new Promise(
        function(resolve_func,reject_func)
        {
            resolve_func(param_data);
        }
    );
}

/**
 * clear the inputs_validation/flash messages
*/
function helper_clear_flash_messages()
{
    //OBJ CONTEXT
    var self=this;
    
    return self.$store.dispatch(
        'component_alert_flash_action_toggle',
        {
            show:false,
            modal:false,
            type:"",
            heading:"",
            message:""
        }
    );
}

/**
 * show loading modal
 * 
 * @param {boolean} param_show
 * @param {string} param_heading
 * @param {string} param_message
*/
function helper_toggle_loading_indicator(param_show,param_heading,param_message)
{
    //OBJ CONTEXT
    var self=this;
    
    return new Promise(
        function(resolve_func,reject_func)
        {
            self.data_component_loading_indicator.prop_show=param_show;
            self.data_component_loading_indicator.prop_type="L";
            self.data_component_loading_indicator.prop_heading=param_heading;
            self.data_component_loading_indicator.prop_message=param_message;

            resolve_func();
        }
    );
}

/**
 * get and parse submission by id
 * 
 * @param {Array} param_id_review_1 id for the first review
 * @param {Array} param_id_review_2 id for the second review
 * @param {Array} param_id_review_3 id for the third review
 */
function helper_load_submissions_reviews(
    param_id_review_1,
    param_id_review_2,
    param_id_review_3
)
{
    //OBJ CONTEXT
    var self=this;

    return new Promise(
        function(resolve_func,reject_func)
        {
            //==============================================
            //genrate the list
            //==============================================
            
            let review_ids=[]
            if(CONFIG.DISABLE_REVIEWS==false)
            {
                if(param_id_review_1!=undefined)
                {
                    review_ids.push(param_id_review_1)
                }
                if(param_id_review_2!=undefined)
                {
                    review_ids.push(param_id_review_2)
                }
                if(param_id_review_3!=undefined)
                {
                    review_ids.push(param_id_review_3)
                }
            }
            else
            {
                if(param_id_review_1!=undefined)
                {
                    review_ids[0]=param_id_review_1
                }
                if(param_id_review_2!=undefined)
                {
                    review_ids[0]=param_id_review_2
                }
                if(param_id_review_3!=undefined)
                {
                    review_ids[0]=param_id_review_3
                }
            }

            //==============================================
            //CLEAR ALL REVIEW DATA
            //==============================================
            Data_Local_Lga_Facility_Submissions_Parsed_Review_1.set.call(
                self,
                []
            ).then(
                function()
                {
                    return Data_Local_Lga_Facility_Submissions_Parsed_Review_2.set.call(
                        self,
                        []
                    )
                }
            ).then(
                function()
                {
                    return Data_Local_Lga_Facility_Submissions_Parsed_Review_3.set.call(
                        self,
                        []
                    )
                }
            )

            //==============================================
            //RUN THE LOOP
            //==============================================

            review_ids.map(
                function(submission_id,review_index)
                {
                    api_request_get_submission_by_id.call(
                        self,
                        submission_id
                    ).then(
                        function(param_data_submission_raw)
                        {
                            //==========================================
                            //PARSE THE SELECTED-FACILITY-NAME
                            //SUBMISSION WITH THE CORRECT ENGINE
                            //==========================================

                            return ENGINES_selector.generate_submissions_display_model(
                                self.$route.params.form_name,
                                param_data_submission_raw.data
                            );
                        }
                    ).then(
                        function(param_generated_display_models)
                        {
                            //==============================================
                            //ADD THE PARSED DATA TO THE LOCAL-STORE
                            //==============================================

                            if(review_index==0)
                            {
                                return Data_Local_Lga_Facility_Submissions_Parsed_Review_1.set.call(
                                    self,
                                    param_generated_display_models
                                )
                            }
                            else if(review_index==1)
                            {
                                return Data_Local_Lga_Facility_Submissions_Parsed_Review_2.set.call(
                                    self,
                                    param_generated_display_models
                                )
                            }
                            else if(review_index==2)
                            {
                                return Data_Local_Lga_Facility_Submissions_Parsed_Review_3.set.call(
                                    self,
                                    param_generated_display_models
                                )
                            }
                        }
                    ).then(
                        function()
                        {
                            //==========================================
                            //SET THE SELECTED PARSED DATA AS THE LAST
                            //AVAILABLE REVIEW
                            //==========================================

                            if(review_index==0)
                            {
                                return Data_Local_Lga_Facility_Submission_Parsed_Selected.set.call(
                                    self,
                                    Data_Local_Lga_Facility_Submissions_Parsed_Review_1.get.call(self)
                                )
                            }
                            else if(review_index==1)
                            {
                                return Data_Local_Lga_Facility_Submission_Parsed_Selected.set.call(
                                    self,
                                    Data_Local_Lga_Facility_Submissions_Parsed_Review_2.get.call(self)
                                )
                            }
                            else if(review_index==2)
                            {
                                return Data_Local_Lga_Facility_Submission_Parsed_Selected.set.call(
                                    self,
                                    Data_Local_Lga_Facility_Submissions_Parsed_Review_3.get.call(self)
                                )
                            }
                        }
                    )
                }
            );

            resolve_func();
        }
    );
}

//########################################################################################
//API_REQUESTS
//########################################################################################

/**
 * Handle Api-Request responses
 * for getting all forms
 * @param {number} param_items_per_page
 * @param {number} param_page
*/
function api_request_get_submissions_summary(
    param_items_per_page,
    param_page
)
{
    //OBJ CONTEXT
    var self=this;
    
    //make sure to call reject func for every non-OK response
    //to jump to the catch of the calling action
    return new Promise(
        function(resolve_func,reject_func)
        {
            Api_Client_E4e_Fmoh_Iss.forms_action_get_submissions_summary(
                self.$route.params.username,
                self.$route.params.form_name,
                self.$route.params.form_id,
                param_items_per_page,
                param_page
            ).then(
                function(api_response){

                    resolve_func(api_response)
                }
            ).catch(
                function(error){
                    reject_func(error);
                }
            );
        }
    );
}

/**
 * Handle Api-Request responses
 * for get a for by id
 * @param {string} param_id
*/
function api_request_get_submission_by_id(param_id)
{
    //OBJ CONTEXT
    var self=this;
    
    //make sure to call reject func for every non-OK response
    //to jump to the catch of the calling action
    return new Promise(
        function(resolve_func,reject_func)
        {
            Api_Client_E4e_Fmoh_Iss.forms_action_get_submission_by_id(
                self.$route.params.username,
                self.$route.params.form_name,
                self.$route.params.form_id,
                param_id
            ).then(
                function(api_response){

                    resolve_func(api_response)
                }
            ).catch(
                function(error){
                    reject_func(error);
                }
            );
        }
    );
}

//########################################################################################
//DATA_OPPS FOR LOCAL STATE
//########################################################################################
/**
 * handler object for local_data
 * submissions_summary
*/
const Data_Local_Submissions_Summary={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_submissions_summary=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_submissions_summary;
    }
}

/**
 * handler object for local_data
 * submission_selected
*/
const Data_Local_Lga_Facility_Submission_Parsed_Selected={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submission_parsed_selected=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submission_parsed_selected;
    }
}

/**
 * handler object for local_data
 * review_1 submission
*/
const Data_Local_Lga_Facility_Submissions_Parsed_Review_1={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submissions_parsed_review_1=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions_parsed_review_1;
    }
}

/**
 * handler object for local_data
 * review_2 submission
*/
const Data_Local_Lga_Facility_Submissions_Parsed_Review_2={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submissions_parsed_review_2=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions_parsed_review_2;
    }
}

/**
 * handler object for local_data
 * review_3 submission
*/
const Data_Local_Lga_Facility_Submissions_Parsed_Review_3={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submissions_parsed_review_3=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions_parsed_review_3;
    }
}

/**
 * handler object for local_data
 * states
*/
const Data_Local_States={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_states=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_states;
    }
}

/**
 * handler object for local_data
 * lgas
*/
const Data_Local_Lgas={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lgas=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lgas;
    }
}

/**
 * handler object for local_data
 * facility_names
*/
const Data_Local_Lga_Facility_Names={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_names=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_names;
    }
}

/**
 * handler object for local_data
 * 
*/
const Data_Local_Lga_Facility_Submissions={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                if(CONFIG.DISABLE_REVIEWS==true)
                {
                    self.data_local_lga_facility_submissions=param_data.slice((param_data.length)-1)
                    //execute resolve function inside setState-after state set callback
                    resolve_func(param_data.slice((param_data.length-1)));
                }
                else
                {
                    //if more than 3 submissions for a facility get the last 3
                    //in order
                    if(param_data.length > 3)
                    {
                        self.data_local_lga_facility_submissions=param_data.slice((param_data.length)-3)
                        //execute resolve function inside setState-after state set callback
                        resolve_func(param_data.slice((param_data.length-3)));
                    }
                    else
                    {
                        self.data_local_lga_facility_submissions=param_data
                        //execute resolve function inside setState-after state set callback
                        resolve_func(param_data);
                    }
                }
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions;
    }
}

//########################################################################################
//ACTIONS
//########################################################################################
/**
 * default action when page loads
 * do initialization here
*/
function action_on_page_load()
{
    //OBJ CONTEXT
    var self=this;

    var api_res_param_retrieved_submissions_summary_full={}
    var api_res_param_retrieved_submissions_summary_data=[]
    var initial_onload_submission=[]

    helper_clear_flash_messages.call(self).then(
        function()
        {
            return helper_toggle_loading_indicator.call(
                self,
                true,
                "loading submissions",
                "please wait..."
            )
        }
    ).then(
        function()
        {
            //=============================================
            //PULL SUBMISSIONS-SUMMARY DATA
            //=============================================

            //IF data exists in the store already pass it down the chain
            //ELSE make new request
            if(self.data_store_submissions_summary==null)
            {
                return api_request_get_submissions_summary.call(
                    self,
                    0,
                    0
                );
            }
            else
            {
                return helper_empty_promise_resolve.call(
                    self,
                    self.$store.state.data_submissions_summary
                )
            }
        }
    ).then(
        function(param_data_retrieved_submissions_summary)
        {
            //=============================================
            //SAVE TO LOCAL-DATA-STORE
            //=============================================

            //full json response
            api_res_param_retrieved_submissions_summary_full=param_data_retrieved_submissions_summary

            //extracted data attribute from full json response
            api_res_param_retrieved_submissions_summary_data=param_data_retrieved_submissions_summary.data

            //extract the first submission to use as on-load initial
            initial_onload_submission=param_data_retrieved_submissions_summary.data[0]

            return Data_Local_Submissions_Summary.set.call(
                self,
                api_res_param_retrieved_submissions_summary_data
            );
        }
    ).then(
        function()
        {
            //=============================================
            //SAVE TO VUEX-STORE
            //=============================================

            //if no data already
            if(self.data_store_submissions_summary==null)
            {
                return self.$store.dispatch(
                    "data_submissions_summary_action_set_all",
                    api_res_param_retrieved_submissions_summary_full
                )
            }
            else
            {
                return helper_empty_promise_resolve.call(
                    self,
                    {}
                )
            }
        }
    ).then(
        function()
        {
            return helper_toggle_loading_indicator.call(
                self,
                true,
                "analysing submissions",
                "please wait..."
            )
        }
    ).then(
        function()
        {
            //=============================================
            //filter and save all states in submissions
            //using a set to remove duplicates
            //=============================================
            return Data_Local_States.set.call(
                self,
                Array.from(
                    new Set(
                        Data_Local_Submissions_Summary.get.call(self).map(
                            function(current_submission)
                            {
                                return current_submission.state
                            }
                        )
                    )
                )
            )
        }
    ).then(
        function()
        {
            //==========================================
            //filter and save all lgas in submissions
            //which has the same [state] as the
            //index[0] submission
            //using a set to remove duplicates
            //==========================================
            return Data_Local_Lgas.set.call(
                self,
                Array.from(
                    new Set(
                        Data_Local_Submissions_Summary.get.call(self).filter(
                            function(current_submission)
                            {
                                if(current_submission.state==initial_onload_submission.state)
                                {
                                    return true
                                }
                                else
                                {
                                    return false
                                }
                            }
                        ).map(
                            //without filter the output will contain undefineds
                            function(current_submission)
                            {
                                return current_submission.lga
                            }
                        )
                    )
                )
            )
        }
    ).then(
        function()
        {
            //====================================================
            //filter and save all facilities-name in submissions
            //which has the same [lga] as the
            //index[0] submission
            //using a set to remove duplicates
            //====================================================
            return Data_Local_Lga_Facility_Names.set.call(
                self,
                Array.from(
                    new Set(
                        Data_Local_Submissions_Summary.get.call(self).filter(
                            function(current_submission)
                            {
                                if(current_submission.lga==initial_onload_submission.lga)
                                {
                                    return true
                                }
                                else
                                {
                                    return false
                                }
                            }
                        ).map(
                            function(current_submission)
                            {
                                return current_submission.facility_name
                            }
                        )
                    )
                )
            )
        }
    ).then(
        function()
        {
            //========================================================
            //filter and save all submissions from a single facility
            //which has the same [facility_name] as the
            //index[0] submission
            //========================================================
            return Data_Local_Lga_Facility_Submissions.set.call(
                self,
                Data_Local_Submissions_Summary.get.call(self).filter(
                    function(current_submission)
                    {
                        if(current_submission.facility_name==initial_onload_submission.facility_name)
                        {
                            return true
                        }
                        else
                        {
                            return false
                        }
                    }
                ).map(
                    function(current_submission)
                    {
                        return {
                            //in the format yyyy-mm-dd hh:mm:ss.nano
                            //split the nano after '.'
                            //and replace ' ' with '/'
                            text:(current_submission.date_created.split(".")[0]).replace(" ","/"),
                            value:(current_submission.instance_id).toString()
                        }
                    }
                )
            )
        }
    ).then(
        function()
        {
            return helper_toggle_loading_indicator.call(
                self,
                true,
                "loading facility submissions",
                "please wait..."
            )
        }
    ).then(
        function()
        {
            //==========================================================
            //LOAD SUBMISSIONS
            //==========================================================

            return helper_load_submissions_reviews.call(
                self,
                Data_Local_Lga_Facility_Submissions.get.call(self)[0]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[0].value,
                Data_Local_Lga_Facility_Submissions.get.call(self)[1]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[1].value,
                Data_Local_Lga_Facility_Submissions.get.call(self)[2]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[2].value,
            )
        }
    ).then(
        function()
        {
            //==========================================
            //RUN END OF CHAIN OPERATIONS
            //==========================================

            //SET THE SELECTS-MODELS TO INITIAL VALUES
            self.data_selected_state=initial_onload_submission.state
            self.data_selected_lga=initial_onload_submission.lga
            self.data_selected_facility_name=initial_onload_submission.facility_name

            //set to the last item(latest)
            self.data_selected_submission_id=Data_Local_Lga_Facility_Submissions.get.call(self)[
                self.data_local_lga_facility_submissions.length-1
            ].value
            //in the format yyyy-mm-dd hh:mm:ss.nano
            //split the nano after '.'
            //and replace ' ' with '/'
            self.data_selected_submission_date=Data_Local_Lga_Facility_Submissions.get.call(self)[
                self.data_local_lga_facility_submissions.length-1
            ].text.split(".")[0].replace(" ","/")

            //CLEAR LOADING-INDICATORS
            helper_toggle_loading_indicator.call(
                self,
                false,
                "",
                ""
            )
        }
    ).catch(
        function(err)
        {
            Facade_Logger.log("prom error catch=>"+err);

            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:true,
                    type:"warning",
                    heading:"Error",
                    message:"Sorry,smothing went wrong please try again later"
                }
            );
        }
    );
}

/**
 * action when state selected
*/
function action_select_state()
{
    //OBJ CONTEXT
    var self=this;

    helper_clear_flash_messages.call(self).then(
        function()
        {
            //==========================================
            //filter and save all lgas in submissions
            //which has the same [state] as the
            //index[0] submission
            //using a set to remove duplicates
            //==========================================
            return Data_Local_Lgas.set.call(
                self,
                Array.from(
                    new Set(
                        Data_Local_Submissions_Summary.get.call(self).filter(
                            function(current_submission)
                            {
                                if(current_submission.state==self.data_selected_state)
                                {
                                    return true
                                }
                                else
                                {
                                    return false
                                }
                            }
                        ).map(
                            //without filter the output will contain undefineds
                            function(current_submission)
                            {
                                return current_submission.lga
                            }
                        )
                    )
                )
            )
        }
    ).catch(
        function(err)
        {
            Facade_Logger.log("prom error catch=>"+err);

            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:true,
                    type:"warning",
                    heading:"Error",
                    message:"Sorry,smothing went wrong please try again later"
                }
            );
        }
    );
}

/**
 * action when lga selected
*/
function action_select_lga()
{
    //OBJ CONTEXT
    var self=this;

    helper_clear_flash_messages.call(self).then(
        function()
        {
            //====================================================
            //filter and save all facilities-name in submissions
            //which has the same [lga] as the
            //index[0] submission
            //using a set to remove duplicates
            //====================================================
            return Data_Local_Lga_Facility_Names.set.call(
                self,
                Array.from(
                    new Set(
                        Data_Local_Submissions_Summary.get.call(self).filter(
                            function(current_submission)
                            {
                                if(current_submission.lga==self.data_selected_lga)
                                {
                                    return true
                                }
                                else
                                {
                                    return false
                                }
                            }
                        ).map(
                            function(current_submission)
                            {
                                return current_submission.facility_name
                            }
                        )
                    )
                )
            )
        }
    ).catch(
        function(err)
        {
            Facade_Logger.log("prom error catch=>"+err);

            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:true,
                    type:"warning",
                    heading:"Error",
                    message:"Sorry,smothing went wrong please try again later"
                }
            );
        }
    );
}

/**
 * action when facility selected
*/
function action_select_facility_name()
{
    //OBJ CONTEXT
    var self=this;

    helper_clear_flash_messages.call(self).then(
        function()
        {
            //========================================================
            //filter and save all submissions from a single facility
            //which has the same [facility_name] as the
            //selected facility name
            //slice to get the first 3
            //========================================================
            return Data_Local_Lga_Facility_Submissions.set.call(
                self,
                Data_Local_Submissions_Summary.get.call(self).filter(
                    function(current_submission)
                    {
                        if(current_submission.facility_name==self.data_selected_facility_name && current_submission.lga==self.data_selected_lga)
                        {
                            return true
                        }
                        else
                        {
                            return false
                        }
                    }
                ).map(
                    function(current_submission)
                    {
                        return {
                            //in the format yyyy-mm-dd hh:mm:ss.nano
                            //split the nano after '.'
                            //and replace ' ' with '/'
                            text:(current_submission.date_created.split(".")[0]).replace(" ","/"),
                            value:(current_submission.instance_id).toString()
                        }
                    }
                )
            )
        }
    ).then(
        function()
        {
            return helper_toggle_loading_indicator.call(
                self,
                true,
                "loading facility submissions",
                "please wait..."
            )
        }
    ).then(
        function()
        {
            //==========================================================
            //LOAD SUBMISSIONS
            //==========================================================

            return helper_load_submissions_reviews.call(
                self,
                Data_Local_Lga_Facility_Submissions.get.call(self)[0]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[0].value,
                Data_Local_Lga_Facility_Submissions.get.call(self)[1]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[1].value,
                Data_Local_Lga_Facility_Submissions.get.call(self)[2]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[2].value,
            )
        }
    ).then(
        function()
        {
            //==========================================
            //RUN END OF CHAIN OPERATIONS
            //==========================================

            //set to the last item(latest)
            self.data_selected_submission_id=Data_Local_Lga_Facility_Submissions.get.call(self)[
                self.data_local_lga_facility_submissions.length-1
            ].value
            //in the format yyyy-mm-dd hh:mm:ss.nano
            //split the nano after '.'
            //and replace ' ' with '/'
            self.data_selected_submission_date=Data_Local_Lga_Facility_Submissions.get.call(self)[
                self.data_local_lga_facility_submissions.length-1
            ].text.split(".")[0].replace(" ","/")

            //CLEAR LOADING-INDICATORS
            helper_toggle_loading_indicator.call(
                self,
                false,
                "",
                ""
            )
        }
    ).catch(
        function(err)
        {
            Facade_Logger.log("prom error catch=>"+err);

            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:true,
                    type:"warning",
                    heading:"Error",
                    message:"Sorry,smothing went wrong please try again later"
                }
            );
        }
    );
}

/**
 * action when submission selected
*/
function action_select_submission()
{
    //OBJ CONTEXT
    var self=this;

    let review_1=Data_Local_Lga_Facility_Submissions_Parsed_Review_1.get.call(self);
    let review_2=Data_Local_Lga_Facility_Submissions_Parsed_Review_2.get.call(self);
    let review_3=Data_Local_Lga_Facility_Submissions_Parsed_Review_3.get.call(self);

    helper_clear_flash_messages.call(self).then(
        function()
        {
            if((review_1.length!=0) && (review_1[0].info.id==self.data_selected_submission_id))
            {
                self.data_selected_submission_id=review_1[0].info.id
                self.data_selected_submission_date=review_1[0].info.submission_time.replace("T"," ")

                return Data_Local_Lga_Facility_Submission_Parsed_Selected.set.call(
                    self,
                    review_1
                )
            }
            else if((review_2.length!=0) && (review_2[0].info.id==self.data_selected_submission_id))
            {
                self.data_selected_submission_id=review_2[0].info.id
                self.data_selected_submission_date=review_2[0].info.submission_time.replace("T"," ")

                return Data_Local_Lga_Facility_Submission_Parsed_Selected.set.call(
                    self,
                    review_2
                )
            }
            else if((review_3.length!=0) && (review_3[0].info.id==self.data_selected_submission_id))
            {
                self.data_selected_submission_id=review_3[0].info.id
                self.data_selected_submission_date=review_3[0].info.submission_time.replace("T"," ")

                return Data_Local_Lga_Facility_Submission_Parsed_Selected.set.call(
                    self,
                    review_3
                )
            }
            else
            {
                //
            }
        }
    ).catch(
        function(err)
        {
            Facade_Logger.log("prom error catch=>"+err);

            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:true,
                    type:"warning",
                    heading:"Error",
                    message:"Sorry,smothing went wrong please try again later"
                }
            );
        }
    );
}
</script>
